import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'

import {
  BatchCollectionMgmtBibliographyBulkRemovalPageLoadResult,
  BatchCollectionMgmtBibliographyBulkRemovalPageLoadResultFromJSON
} from '@/api/models/batch/BatchCollectionMgmtBibliographyBulkRemovalPageLoadResult'
import {
  BatchCollectionMgmtBibliographyBulkRemovalRequest,
  BatchCollectionMgmtBibliographyBulkRemovalRequestToJSON
} from '@/api/models/batch/BatchCollectionMgmtBibliographyBulkRemovalRequest'

export class BatchCollectionMgmtBibliographyBulkRemovalApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchCollectionMgmtBibliographyBulkRemovalPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchCollectionMgmtBibliographyBulkRemovalPageLoadResultFromJSON(
        jsonValue
      )
    ).value()
  }

  async createCollectionMgmtBulkRemoval(
    request: BatchCollectionMgmtBibliographyBulkRemovalRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/collection-management/bulk-removal`,
      BatchCollectionMgmtBibliographyBulkRemovalRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
